import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, FormArray} from '@angular/forms';
import {UtilService} from '../../../../../shared/_services/util.service';
import {HcaMemberService} from '../../../../../shared/_services/hca-member.service';
import {HcaUserManagementService} from '../../../../../shared/_services/hca-user-management.service';

@Component({
  selector: 'app-physical-cards-list',
  templateUrl: './physical-cards-list.component.html',
  styleUrls: ['./physical-cards-list.component.scss']
})
export class PhysicalCardsListComponent implements OnInit {
  physicalCardForm: FormGroup;
  searchForm: FormGroup;
  private _searchTerm: FormControl;
  totalCount: any;
  p: number = 0;
  size: number = 10;
  isFiltered: any;
  isFilterOn: any;
  actionSvg = 'assets/images/action-inactive.svg';
  memberRulesList: any;
  brandsList: any[] = [];
  selectedBrands: any[] = [];
  brandHotels: any[] = [];
  countriesList: any[] = [];
  tableHeader: any = [
    {'key': 'Member Name', 'property': 'name', 'direction': 'asc'},
    {'key': 'Hotel', 'property': 'hotel', 'direction': null},
    {'key': 'Country', 'property': 'country', 'direction': null},
    {'key': 'Address', 'property': 'address', 'direction': null},
    {'key': 'Status', 'property': 'status', 'direction': null}
  ];
  cardsList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private utilService: UtilService,
    private hcaMemberService: HcaMemberService,
    private hcaUserManagementService: HcaUserManagementService
  ) {
  }

  dropDown(e) {
    // event.stopPropagation();
    if (document.getElementById('physical-card-filter').style.display == 'block') {
      document.getElementById('physical-card-filter').style.display = 'none';
    } else {
      document.getElementById('physical-card-filter').style.display = 'block';
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  getSelectedStr(length, type) {
    return `${length} ${type}${length !== 1 ? 's' : ''} Selected`;
  }

  clearDate() {
    if (this.physicalCardForm.get('range').value) {
      this.physicalCardForm.get('range').setValue(null);
      this.physicalCardForm.get('startDate').setValue(null);
      this.physicalCardForm.get('endDate').setValue(null);
    }
  }

  get searchTerm(): FormControl {
    return this.searchForm.get('searchTerm') as FormControl;
  }

  getHotelsList() {
    let brandIds = this.utilService.cleanArray(this.selectedBrands);
    //let hotelIds = this.utilService.cleanArray(this.selectedHotels);
    let formArray = this.physicalCardForm.controls['hotelIds'] as FormArray;
    this.clearFormArray(formArray);
    this.hcaUserManagementService.getHotelsByBrand(brandIds).subscribe((res: any) => {
      if (res.error == 0) {
        this.brandHotels = res.responseObj;
        if (this.brandHotels) {
          let noneHotel = {
            hotelId: -1,
            hotelName: 'None',
          };
          this.brandHotels.push(noneHotel);
          this.brandHotels.forEach(element => {
            this.checkSelected(true, 'hotelIds', 'hotelId', element.hotelId);
          });
        }
      } else {
        this.brandHotels = [];
      }
    }, err => {
      this.brandHotels = [];
    });
  }


  checkSelected(isChecked: boolean, controlName, valueType, value) {
    let formArray = this.physicalCardForm.controls[controlName] as FormArray;
    if (isChecked) {

      formArray.push(new FormControl(value));
    } else {
      let index = formArray.controls.findIndex(x => x.value == value);
      if (index > -1) {
        formArray.removeAt(index);
      }
      if (formArray.value.indexOf(0) > -1) {
        if (this.brandHotels.length != formArray.value.length - 1) {
          let idx = formArray.controls.findIndex(x => x.value == 0);
          if (idx > -1) {
            formArray.removeAt(idx);
          }
        }
      }
    }
  }

  checkSelection(isChecked?: boolean, control?, type?, id?) {
    const formControl = <FormArray>this[control];
    if (isChecked) {
      if (type == 'brand') {
        formControl.controls['brands'].push(new FormControl(id));
        this.selectedBrands = formControl.controls['brands'].value;
        // if(this.selectedBrands && this.selectedBrands.length) {
        this.getHotelsList();
        // }
      } else {
        formControl.controls['country'].push(new FormControl(id));
        this.selectedBrands = formControl.controls['country'].value;
      }
    } else {
      if (type == 'brand') {
        let index = formControl.controls['brands'].controls.findIndex(x => x.value == id);
        formControl.controls['brands'].removeAt(index);
        this.selectedBrands = formControl.controls['brands'].value;
        // if(this.selectedBrands && this.selectedBrands.length) {
        this.getHotelsList();
        // }
      } else {
        let index = formControl.controls['country'].controls.findIndex(x => x.value == id);
        formControl.controls['country'].removeAt(index);
        this.selectedBrands = formControl.controls['country'].value;
      }
    }
  }


  sortTable(property: any, ignoreFields?) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = null;
      }
    });
    if (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1) {
      this.pageChanged(1);
    }
  }

  getPhysicalCardRules() {
    this.hcaMemberService.getPhysicalCardRules().subscribe(res => {
      if (res.error == 0) {
        this.memberRulesList = res.responseObj;
        this.brandsList = res.responseObj.brands;
        this.countriesList = res.responseObj.countries;
        this.selectedBrands = this.utilService.cleanArray(this.brandsList.map(brand => {
          if (brand.checked) {
            this.checkSelection(brand.checked, this.physicalCardForm, 'brand', brand.brandId);
          }
        }));
        if (this.selectedBrands && this.selectedBrands.length) {
          this.getHotelsList();
        }
      }
    });
  }


  checkFilterOn() {
    let formGroup = this.physicalCardForm.value;
    if (!formGroup.startDate && !formGroup.endDate && formGroup.status && formGroup.status == 'all' && formGroup.country && !formGroup.country.length && formGroup.hotelIds && !formGroup.hotelIds.length) {
      return false;
    } else {
      return true;
    }
  }

  initFilterForm() {
    let hotels = this.fb.array([]);
    this.physicalCardForm = new FormGroup({
      status: new FormControl('all'),
      country: new FormArray([]),
      brands: new FormArray([]),
      hotelIds: hotels,
      range: new FormControl(null),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
    });
    this.physicalCardForm.controls['range'].valueChanges.debounceTime(400).subscribe(value => {
      if (!value || (value && !value.length)) {
        this.physicalCardForm.get('startDate').setValue(null);
        this.physicalCardForm.get('endDate').setValue(null);
      } else {
        this.physicalCardForm.get('startDate').setValue(value[0] ? this.utilService.formatDate(value[0]) : null);
        this.physicalCardForm.get('endDate').setValue(value[1] ? this.utilService.formatDate(value[1]) : null);
      }
    }, err => {
      console.error('date', err);
    });
    this.physicalCardForm.valueChanges.debounceTime(600).subscribe(value => {
      this.isFilterOn = this.checkFilterOn();
      this.pageChanged(1);
    });
  }

  initSearchForm() {
    this.searchForm = new FormGroup({
      searchTerm: new FormControl('')
    });
    this.searchForm.get('searchTerm').valueChanges.debounceTime(400).distinctUntilChanged()
      .subscribe(term => {
        this.pageChanged(1);
      });
  }


  checkGroupFilter() {
    if (!this.isFilterOn && !this.searchForm.get('searchTerm').value) {
      return false;
    } else {
      return true;
    }
  }

  getPhysicalCardsList(page?) {
    let data = {
      filter: this.physicalCardForm.value,
      isFilterOn: this.isFilterOn,
      pageNumber: page != null ? page : this.p,
      hotelChainId: JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId,
      value: this.searchForm.get('searchTerm').value,
      sorting: this.tableHeader
    };
    this.hcaMemberService.getPhysicalCardsList(data).subscribe(res => {
      if (res.error == 0) {
        this.isFiltered = this.checkGroupFilter();
        this.cardsList = res.responseObj.results;
        this.totalCount = res.responseObj.totalRecords ? res.responseObj.totalRecords : res.responseObj.results.length;
      }
    }, err => {
      console.error('Error while fetching Booking List: ', err.message);
    });
  }

  pageChanged($event) {
    let page = $event - 1;
    this.getPhysicalCardsList(page);
    this.p = $event;
  }

  ngOnInit() {
    this.getPhysicalCardRules();
    this.initFilterForm();
    this.initSearchForm();
    this.getPhysicalCardsList();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/physical-cards/physical-cards-list/physical-cards-list.component.ts